import { Row, Col } from "reactstrap";
import { useTranslation } from "react-i18next";
import ServiceCard from "./ServiceCard";

import "../styles/ServiceCardGrid.css";

import serviceicon1 from "../resources/serviceicon1.png";
import serviceicon2 from "../resources/serviceicon2.png";
// import serviceicon3 from "../resources/serviceicon3.png";

const ServiceCardGrid = () => {
  const { t } = useTranslation();

  return (
    <Row className="service-card-grid">
      <Col>
        <ServiceCard
          icon={serviceicon1}
          title={t("mission_title")}
          text={t("mission_description")}
        />
      </Col>
      <Col>
        <ServiceCard
          icon={serviceicon2}
          title={t("history_title")}
          text={t("history_description_short")}
        />
      </Col>
      {/* <Col>
        <ServiceCard
          icon={serviceicon3}
          title="Cybersecurity"
          text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed felis felis,
                          ultrices et molestie semper, tincidunt non augue."
        />
      </Col> */}
    </Row>
  );
};
export default ServiceCardGrid;
